export default __webpack_public_path__ + "static/media/logo_symbol.11f7698a.svg";